// extracted by mini-css-extract-plugin
export default {"tab_container":"styles_tab_container__WEHv9","tab_item":"styles_tab_item__jQ-CA","active":"styles_active__hz1PX"};